// src/icons/svgs/empty.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgEmpty = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref, ...props, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#0b4ba)", children: [
    /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "#fff", rx: 4 }),
    /* @__PURE__ */ jsx("path", { stroke: "#E64980", strokeWidth: 2, d: "m24.707-.293-24 24" })
  ] }),
  /* @__PURE__ */ jsx("rect", { width: 23.5, height: 23.5, x: 0.25, y: 0.25, stroke: "#ADB5BD", strokeWidth: 0.5, rx: 3.75 }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "0b4ba", children: /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "#fff", rx: 4 }) }) })
] });
var ForwardRef = forwardRef(SvgEmpty);
var empty_default = ForwardRef;
export {
  empty_default as Empty
};
